import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { PhoneCall, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { telHref } from "../lib/api";
import { useLang } from "../context/LanguageContext";

const icon = L.divIcon({
  className: "",
  html: `<div style="background:#2E604A;width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid #fff;box-shadow:0 3px 8px rgba(0,0,0,.3)"></div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30],
});

const AUCKLAND = [-36.8485, 174.7633];

export default function MapView() {
  const { t } = useLang();
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    api.get("/organizations").then((r) => setOrgs(r.data.filter((o) => o.lat && o.lng)));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-8 fade-up">
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-stone-900">{t("map_title")}</h1>
      <p className="mt-2 text-stone-600">{t("map_sub")}</p>

      <div className="mt-6 rounded-3xl overflow-hidden border border-stone-200 shadow-sm" style={{ height: "70vh" }} data-testid="map-container">
        <MapContainer center={AUCKLAND} zoom={11} scrollWheelZoom style={{ height: "100%", width: "100%" }}>
          <TileLayer
            attribution='&copy; OpenStreetMap contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {orgs.map((org) => {
            const phone = org.contact?.freephone || org.contact?.phone;
            const num = telHref(phone);
            return (
              <Marker key={org._id} position={[org.lat, org.lng]} icon={icon}>
                <Popup>
                  <div style={{ minWidth: 180 }}>
                    <strong style={{ fontSize: 14 }}>{org.name}</strong>
                    <p style={{ margin: "6px 0", fontSize: 12, color: "#57534E" }}>{org.contact?.address}</p>
                    <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
                      {num && (
                        <a href={`tel:${num}`} style={{ display: "inline-flex", alignItems: "center", gap: 4, background: "#2E604A", color: "#fff", padding: "5px 10px", borderRadius: 999, fontSize: 12, fontWeight: 600, textDecoration: "none" }}>
                          {t("call")}
                        </a>
                      )}
                      <Link to={`/organisation/${org._id}`} style={{ display: "inline-flex", alignItems: "center", gap: 4, color: "#2E604A", fontSize: 12, fontWeight: 600 }}>
                        {t("contact")}
                      </Link>
                    </div>
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MapContainer>
      </div>
    </div>
  );
}
